import { useAngularContext } from 'AngularContext';

export function useOfflineModeManager() {
    const $injector = useAngularContext();
    const offlineModeManager = $injector.get<{ inOfflineMode: boolean }>('offlineModeManager');
    return offlineModeManager;
}
